// import React, { useState } from "react";

// type Tab = {
//   id: string;
//   label: string;
//   content: JSX.Element;
// };

// interface TabsProps {
//   tabs: Tab[];
//   initialActiveTab?: string;
//   className?: string;
// }

// const HorizontalTabs: React.FC<TabsProps> = ({
//   tabs,
//   initialActiveTab,
//   className,
// }) => {
//   const [activeTab, setActiveTab] = useState<string>(
//     initialActiveTab || tabs[0]?.id
//   );

//   return (
//     <div className={`w-full ${className}`}>
//       <div className="flex border-b">
//         {tabs.map((tab) => (
//           <button
//             key={tab.id}
//             onClick={() => setActiveTab(tab.id)}
//             className={`px-4 py-2 focus:outline-none transition-colors duration-200 ${
//               activeTab === tab.id
//                 ? "border-b-2 border-gray-700 font-semibold"
//                 : "text-gray-600 hover:text-gray-800"
//             }`}
//           >
//             {tab.label}
//           </button>
//         ))}
//       </div>
//       <div className="p-4">
//         {tabs.find((tab) => tab.id === activeTab)?.content}
//       </div>
//     </div>
//   );
// };

// export default HorizontalTabs;
type Tab = {
  id: string;
  label: string;
  content: JSX.Element;
};

interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  setActiveTab: (id: string) => void;
  className?: string;
}

const HorizontalTabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  setActiveTab,
  className,
}) => {
  return (
    <div className={`w-full ${className}`}>
      <div className="flex border-b">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2 focus:outline-none transition-colors duration-200 ${
              activeTab === tab.id
                ? "border-b-2 border-gray-700 font-semibold"
                : "text-gray-600 hover:text-gray-800"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="p-4">
        {tabs.find((tab) => tab.id === activeTab)?.content}
      </div>
    </div>
  );
};

export default HorizontalTabs;
